import { Order } from "../../../models/SortOrder"
import { NexPageSize } from "./NexPageSize"

export interface PagingFilters<T extends string> {
    page: number
    page_size: NexPageSize
    order: Order

    // String Enum
    ordering: T
}

export const generateSearchParamsForDjango = <T extends string>(params: PagingFilters<T> & object) => {
    // if the order is desc add a minus before the orderBy string
    const orderDirectionSpecifier = params.order === "desc" ? "-" : ""

    const searchParams = new URLSearchParams({
        // Page starts at one on the backend
        page: String(params.page + 1),
        ordering: `${orderDirectionSpecifier}${params.ordering},id`,
        page_size: String(params.page_size),
    })

    const withoutPagingParams: object = {
        ...params,
        page: undefined,
        ordering: undefined,
        page_size: undefined,
        order: undefined,
    }

    for (const [key, value] of Object.entries(withoutPagingParams)) {
        // Only append if it is not a part of the paging filters
        if (Array.isArray(value)) {
            value.forEach((arrVal) => {
                searchParams.append(key, arrVal.trim())
            })
        } else if (typeof value === "string" && value.trim() !== "") {
            searchParams.append(key, value.trim())
        }
    }

    return searchParams
}
